import {FC, ReactNode} from 'react'
import classNames from 'classnames'
import {RenderIf} from '../RenderIf'

const textToBeBlurred =
  'This is some random text that will be blurred if paywall is true. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna.'
export interface DopamineCardProps {
  titleClassName?: string
  excerptSummary: ReactNode
  excerptSummaryClassName?: string
  isLoading: boolean
  loadingText: string
  className?: string
  paywall: boolean
  paywallMessage: ReactNode
}

export const DopamineCard: FC<DopamineCardProps> = ({
  titleClassName,
  excerptSummary,
  excerptSummaryClassName,
  isLoading,
  className,
  loadingText,
  paywall,
  paywallMessage,
}) => {
  const dopamineCardBackground = 'bg-white/[0.075]'
  const dopamineCardShadow = 'shadow-[0_4px_6px_rgba(0,0,0,0.2)]'

  return (
    <div
      className={classNames(
        // Base styles
        'relative flex flex-col gap-1.5 text-sm text-white p-3.5 pl-4 rounded',
        dopamineCardBackground,
        dopamineCardShadow,
        // Before pseudo-element for gradient border and background
        'before:content-[""] before:absolute before:inset-0 before:rounded before:border-0.5 before:border-white/15',
        'before:bg-gradient-to-br before:from-dope-purple-500/40 before:via-dope-purple-400/30 before:to-dope-purple-500/40',
        className,
      )}
      data-cy="dopamine-card"
    >
      {/* DescriptionCardTitle */}
      <h3
        className={classNames('leading-3.5', titleClassName)}
        data-cy="dopamine-card-title"
      >
        <span className="abc-bold">DOP</span>
        <span className="cositimes">AMINE</span>
      </h3>

      {/* ExcerptSummary or ExcerptSummarySkeleton */}
      <RenderIf isTrue={isLoading}>
        <div
          className={classNames(
            'h-10 karla text-xs text-white font-normal leading-4.5',
            excerptSummaryClassName,
          )}
        >
          {loadingText}
        </div>
      </RenderIf>
      <RenderIf isTrue={!isLoading}>
        <div
          className={classNames(
            'karla text-xs font-normal leading-4.5 z-[1] break-words',
            excerptSummaryClassName,
            {'text-dope-purple-600 blur-sm': paywall},
            {'text-white': !paywall},
          )}
          data-cy="dopamine-card-summary"
        >
          {(paywall && textToBeBlurred) || excerptSummary}
        </div>
      </RenderIf>

      {/* Paywall overlay */}
      <RenderIf isTrue={!isLoading && paywall}>
        <div
          data-cy="dopamine-card-paywall-container"
          className="absolute top-4 left-0 inset-0 flex justify-center p-4 rounded z-10"
        >
          <p
            data-cy="dopamine-card-paywall-message"
            className="text-white text-xs karla font-normal leading-4.5 mt-1.5"
          >
            {paywallMessage}
          </p>
        </div>
      </RenderIf>
    </div>
  )
}
